var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 68,
    viewBox: "0 0 309 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00024 34.0001C1.00024 52.2255 15.7748 67.0001 34.0002 67.0001L267 67.0001C285.226 67.0001 300 52.2255 300 34.0001C300 15.7747 285.226 1.00009 267 1.00009L34.0002 1.00011C15.7748 1.00011 1.00024 15.7747 1.00024 34.0001Z",
    stroke: "url(#paint0_linear_406_196)",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 34.0001C9.00024 52.2255 23.7748 67.0001 42.0002 67.0001L259 67.0001C277.226 67.0001 292 52.2255 292 34.0001C292 15.7747 277.226 1.00009 259 1.00009L42.0002 1.00011C23.7748 1.00011 9.00024 15.7747 9.00024 34.0001Z",
    stroke: "url(#paint1_linear_406_196)",
    strokeOpacity: 0.67,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 34.0001C17.0002 52.2255 31.7748 67.0001 50.0002 67.0001L251 67.0001C269.226 67.0001 284 52.2255 284 34.0001C284 15.7747 269.226 1.00009 251 1.00009L50.0002 1.00011C31.7748 1.00011 17.0002 15.7747 17.0002 34.0001Z",
    stroke: "url(#paint2_linear_406_196)",
    strokeOpacity: 0.67,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_196",
    x1: 301,
    y1: 30.5001,
    x2: 0.000245017,
    y2: 30.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116837,
    stopColor: "#ABFF29",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914323,
    stopColor: "#ABFF29",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_196",
    x1: 293,
    y1: 30.5001,
    x2: 8.00024,
    y2: 30.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116837,
    stopColor: "#ABFF29",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914323,
    stopColor: "#ABFF29",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_196",
    x1: 285,
    y1: 30.5001,
    x2: 16.0002,
    y2: 30.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABFF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116837,
    stopColor: "#ABFF29",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914323,
    stopColor: "#ABFF29",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFF29"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.bb2fe89148f00814ad428473c1218921.svg";
export { ForwardRef as ReactComponent };